import { Observable } from 'rxjs';
import { InstitutionModel, ProgramSearchResultModel } from '../../models';

export abstract class BaseInstitutionService {
  public resultCount$;

  public abstract getInstitution(pathNid: string): Observable<InstitutionModel>;
  public abstract getInstitutions(): Observable<InstitutionModel[]>;
  public abstract getProgramsForInstitution(institutionId: string, isSponsored: boolean): Observable<ProgramSearchResultModel[]>;
  public abstract getPreviewProgramsForInstitution(institutionId: string): Observable<ProgramSearchResultModel[]>;
  public abstract searchInstitutions(keyword, filter, page, itemCount?): Observable<any>;
}
